export const SITE_INFO = {
  name: "KerneViden",
  tagline: "En tryg vej til forandring. Hvor krop, nervesystem og samtale viser vejen.",
  cvr: "46676327",
  phone: "20 99 21 49",
  phoneFormatted: "+45 20 99 21 49",
  email: "Kontakt@kerneviden.dk",
  address: "Farimagsvej 26",
  zipCity: "4700 Næstved",
  consultAddress: "Farimagsvej 26, 4700 Næstved",
  facebookUrl: "https://www.facebook.com/profile.php?id=61593229641220",
  logoUrl: "https://assets.auxodev.dk/assets/1d30bca3-a748-4ede-8335-828014d68a29/logo.png",
  faviconUrl: "https://assets.auxodev.dk/assets/1d30bca3-a748-4ede-8335-828014d68a29/sb-favicon.svg",
};

export const NAVIGATION_MENU = [
  { label: "Hjem", href: "/" },
  { label: "Forløb", href: "/vores-tjenester" },
  { label: "Om KerneViden", href: "/om-os" },
  { label: "Kontakt", href: "/kontakt" },
  { label: "Blogindlæg", href: "/blogindlaeg" },
  {
    label: "Vis mere",
    href: "",
    children: [
      { label: "Hjem", href: "/" },
      { label: "Forløb", href: "/vores-tjenester" },
      { label: "Om KerneViden", href: "/om-os" },
      { label: "Kontakt", href: "/kontakt" },
      { label: "Blogindlæg", href: "/blogindlaeg" },
    ],
  },
];

export const CORE_PILLARS = [
  {
    id: "udgangspunkt-i-dig",
    title: "Udgangspunkt i dig.",
    description: "Mennekser regulerer sig forskelligt. Derfor starter jeg der, hvor du er.",
    image: "https://assets.auxodev.dk/assets/1d30bca3-a748-4ede-8335-828014d68a29/fullsizerender-4.jpeg",
    icon: "fa-solid fa-seedling",
  },
  {
    id: "fleksible-rammer",
    title: "Fleksible rammer.",
    description: "I samtalerum, på en rolig gåtur i naturen eller hjemme hos dig.",
    image: "https://assets.auxodev.dk/assets/1d30bca3-a748-4ede-8335-828014d68a29/fullsizerender-2.jpeg",
    icon: "fa-solid fa-person-walking",
  },
  {
    id: "i-dit-tempo",
    title: "I dit tempo.",
    description: "Jeg møder dig i dit eget tempo, når du føler dig tryg.",
    image: "https://assets.auxodev.dk/assets/1d30bca3-a748-4ede-8335-828014d68a29/fullsizerender-3.jpeg",
    icon: "fa-solid fa-feather-pointed",
  },
  {
    id: "reduceret-pris",
    title: "Reduceret pris.",
    description: "Kvalificeret forløb under videreuddannelse til Neuroaffektiv Psykoterapeut.",
    image: "https://assets.auxodev.dk/assets/1d30bca3-a748-4ede-8335-828014d68a29/fullsizerender-7.jpeg",
    icon: "fa-solid fa-hand-holding-heart",
  },
  {
    id: "neuroaffektiv-tilgang",
    title: "Neuroaffektiv tilgang.",
    description: "Et perspektiv med udgangspunkt i krop, sind og regulering.",
    image: "https://assets.auxodev.dk/assets/1d30bca3-a748-4ede-8335-828014d68a29/fullsizerender-6.jpeg",
    icon: "fa-solid fa-brain",
  },
  {
    id: "et-trygt-sted",
    title: "Et trygt sted.",
    description: "I Næstved, online eller ved hjemmebesøg i lokalområdet.",
    image: "https://assets.auxodev.dk/assets/1d30bca3-a748-4ede-8335-828014d68a29/fullsizerender-5.jpeg",
    icon: "fa-solid fa-house-chimney-heart",
  },
];
